import React, { useState } from 'react';
import useInterval from './use_interval';
import moment from 'moment';

const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);

const RelativeDatetime = props => {
  const { timestamp } = props;
  const m = moment;

  m.relativeTimeThreshold('s', 55);
  m.relativeTimeThreshold('ss', 5);

  const calculateRelativeTime = () =>
    capitalize(
      m(timestamp)
        .parseZone()
        .fromNow()
    );
  const [relativeTime, setRelativeTime] = useState(calculateRelativeTime());

  useInterval(() => {
    setRelativeTime(calculateRelativeTime());
  }, 60000);

  return <span>{relativeTime}</span>;
};

export default RelativeDatetime;



// WEBPACK FOOTER //
// ./app/javascript/app/components/toolkit/relative_datetime.jsx